// Shared copy for features that are not currently enabled. Used by both the
// FeatureUnavailablePage and the greyed-out start-page tiles so the wording
// stays identical.
export const buildFeatureUnavailableHeadline = (featureName: string): string =>
    `${featureName} ist derzeit nicht verfügbar.`;

export const buildFeatureUnavailableBody = (featureName: string): string =>
    `Bitte versuchen Sie es später erneut oder kontaktieren Sie Ihren ETERNO-Ansprechpartner, um ${featureName} freischalten zu lassen.`;
